export default __webpack_public_path__ + "static/page.light-bb83e6c21e87760d3619a638ca64936be3f731d8562a6eadf760fe90ed07b76e.png";